<template>
  <svg
    width="46"
    height="17"
    viewBox="0 0 46 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="1" width="45" height="15" rx="7.5" fill="white" />
    <path
      d="M12.96 5.21H11.92V10.91L7.84 5.21H6.72V12.57H7.76V6.88L11.84 12.57H12.96V5.21ZM19.5534 5.21H14.5034V12.57H15.5434V9.33H18.9034V8.43H15.5434V6.11H19.5534V5.21ZM25.8665 5.21H20.4365V6.11H22.6365V12.57H23.6765V6.11H25.8665V5.21Z"
      fill="#666666"
    />
    <circle
      cx="34.5"
      cy="8.5"
      r="4.5"
      fill="white"
      stroke="#F5222D"
      stroke-width="2"
    />
    <line
      x1="31.2525"
      y1="5.40811"
      x2="37.931"
      y2="11.6146"
      stroke="#F5222D"
      stroke-width="2"
    />
    <rect x="0.5" y="1" width="45" height="15" rx="7.5" stroke="#CCCCCC" />
  </svg>
</template>

<style scoped></style>
